import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = { class: "text-h4 text-bold text-green-7" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_breadcrumb_list = _resolveComponent("breadcrumb-list");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "col column no-wrap" }, {
        default: _withCtx(() => [
            _createVNode(_component_breadcrumb_list, {
                breadCrumbs: [
                    ...(_ctx.hasAddress
                        ? [
                            { itemId: _ctx.PageID.top },
                            { itemId: _ctx.PageID.keiyaku },
                            { itemId: _ctx.PageID.mailaddressChange }
                        ]
                        : [{ itemId: _ctx.PageID.mailaddressConfig }]),
                    { itemId: _ctx.PageID.mailaddressCheck },
                    { itemId: _ctx.PageID.mailaddressChangeComplete }
                ]
            }, null, 8, ["breadCrumbs"]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pageName), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                    _createElementVNode("div", { class: "q-pa-md" }, [
                                        _createElementVNode("div", { class: "table-caption" }, " メールアドレスの変更が完了しました。 ")
                                    ], -1)
                                ]))]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    label: _ctx.hasAddress ? '照会に戻る' : 'トップに戻る',
                                    class: "btn-route col-5 col-md-3",
                                    color: "grey-8",
                                    icon: "navigate_before",
                                    onClick: _ctx.onClick
                                }, null, 8, ["label", "onClick"])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
